import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Row from 'ravenjs/lib/Row';
import Select from 'ravenjs/lib/Select';
import Typography from 'ravenjs/lib/Typography';
import { themeGet } from 'ravenjs/utils/theme';

const PaginationRowsPerPageStyled = styled(Row)`
    /**
     * Add all of the remaining styles from theme
     */
    ${themeGet('PaginationRowsPerPage.styles')};
`;

function PaginationRowsPerPage(props) {
    const { label, onChange, rowsPerPage, rowsPerPageOptions, menuPlacement } = props;
    // Build the options list for the Select Component.
    const options = rowsPerPageOptions.map(option => ({ label: option, value: option }));
    // Build the current default value.
    const value = {
        label: rowsPerPage,
        value: rowsPerPage,
    };
    // Render the Pagination RowsPerPage.
    return (
        <PaginationRowsPerPageStyled
            alignItems="center"
            gutter={false}
            justify="flex-start"
            width="auto"
            wrap="nowrap"
        >
            {label && (
                <Typography
                    color="text"
                    fontSize="0.75rem"
                    fontFamily="RobotoMono"
                    gutterBottom="0"
                    gutterRight="10px"
                    gutterTop="0"
                    type="paginationLabel"
                >
                    {label.toUpperCase()}
                </Typography>
            )}
            <Select
                defaultValue={value}
                isClearable={false}
                isSearchable={false}
                minWidth="80px"
                name="pagination-rows-per-page"
                onChange={onChange}
                options={options}
                value={value}
                menuPlacement={menuPlacement}
            />
        </PaginationRowsPerPageStyled>
    );
}

PaginationRowsPerPage.propTypes = {
    /**
     * Rows per page Label.
     */
    label: PropTypes.string,
    /**
     * `onChange` handler for the select-dropdown.
     */
    onChange: PropTypes.func,
    /**
     * The current number of `rowsPerPage`.
     */
    rowsPerPage: PropTypes.number,
    /**
     * A list of options for the `rowsPerPage` select-dropdown.
     */
    rowsPerPageOptions: PropTypes.array,
    /**
     * Menu position.
     */
    menuPlacement: PropTypes.string,
};

PaginationRowsPerPage.defaultProps = {
    label: '',
    onChange: () => {},
    rowsPerPage: 10,
    rowsPerPageOptions: [20, 10, 5],
    menuPlacement: 'auto',
};

export default PaginationRowsPerPage;
